import React from 'react';
import { marked } from 'marked';

const Markdown = ({ content }) => {
  const createMarkup = () => {
    return { __html: marked(content) };
  };

  return <p dangerouslySetInnerHTML={createMarkup()} />;
};

export default Markdown;
